import React from "react";

import Footer from 'components/home_footer'
import BannerTwoText from "components/banner2_text";

import styles from './banner2_page.module.css'

import fourth from 'static/fourth.jpg'

import Nabar from "components/Nabar";
import MainSearch from "components/main_search";

const BannerTwoPage = () => {

  
  return ( 
    <div>
      <Nabar/>
      <div className='hero-banner magic-ball home'>
        <div className='main-banner'>
          <img src={fourth} alt='front pic' />
          <MainSearch banner={true}/>
        </div>
      </div>

        <BannerTwoText/>

      <div className={styles.footer}>
          <Footer/>
      </div> 
    </div>
  );
}

export default BannerTwoPage;